import * as React from "react";

/// <reference path="../../../Frontend.Core/dist/definitions/NCB.d.ts" />

interface ICurrencyConverterProps {
    currency: string,
    price: number,
    prefix?: string,
    suffix?: string,
    hideCurrency?: boolean
}

interface ICurrencyConverterState {
    convertedPrice: number
}

export class CurrencyConverter extends React.Component<ICurrencyConverterProps, ICurrencyConverterState> {

    constructor (props: ICurrencyConverterProps) {
        super(props);

        this.props = props;

        this.state = {
            convertedPrice: this.getConvertedPrice(props.currency, props.price)
        }
    }

    componentWillReceiveProps(nextProps: ICurrencyConverterProps) {
        if (this.props.currency !== nextProps.currency || this.props.price !== nextProps.price || this.props.prefix !== nextProps.prefix || this.props.suffix !== nextProps.suffix)
            this.setState({
                convertedPrice: this.getConvertedPrice(nextProps.currency, nextProps.price)
            });
    }

    getConvertedPrice = (targetCurrency: string, sourceAmount: number): number => {

        if (targetCurrency === NCB.Settings.Currency)
            return sourceAmount;

        return NCB.CurrencyHelper.getConvertedPrice(NCB.Settings.Currency, sourceAmount, targetCurrency);
    }
    
    render() {

        let priceString = "" + (this.props.prefix != null ? this.props.prefix : "") + NCB.Utils.formatPrice(this.state.convertedPrice);

        if (this.props.suffix != null)
            priceString += this.props.suffix;

        return <span className="ncb-currencyconverter-price" data-string-length={priceString.length} data-currency={this.props.currency} data-source-currency={NCB.Settings.Currency} data-source-price={this.props.price}><span className="ncb-currencyconverter-price-amount">{priceString}</span> {(this.props.hideCurrency === true ? null : <span className="ncb-currencyconverter-price">{this.props.currency}</span>)}</span>
    }
}


// WEBPACK FOOTER //
// ./src/components/shared/currencyConverter.tsx